import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { LeafDivider } from '../ui/LeafDivider';
import { CheckCircle2, XCircle } from 'lucide-react';
export function Audience() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 px-4 bg-cream-100" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        {/* Who is it for / not for */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20" data-id="element-3">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={containerVariants} className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-sage-300/30" data-id="element-4">
            <motion.h3 variants={itemVariants} className="text-2xl font-bold font-playfair mb-6 flex items-center" data-id="element-5">
              <span className="bg-sage-300/30 p-2 rounded-full mr-3" data-id="element-6">
                <CheckCircle2 className="w-6 h-6 text-sage-500" data-id="element-7" />
              </span>
              Para quién es esto:
            </motion.h3>
            <ul className="space-y-4" data-id="element-8">
              {['Mujeres que tienen un evento importante (boda, fiesta, sesión de fotos) en menos de 48 horas.', "Profesionales con altos niveles de estrés que sufren de 'vientre de oficina' al final del día.", 'Latinas en EE.UU. que buscan una solución natural y rápida para la retención de líquidos.', "Personas que se sienten 'pesadas' y estancadas a pesar de comer saludablemente."].map((text, i) => <motion.li key={i} variants={itemVariants} className="flex items-start" data-id="element-9">
                  <div className="w-1.5 h-1.5 rounded-full bg-sage-500 mt-2.5 mr-3 flex-shrink-0" data-id="element-10"></div>
                  <span className="text-forest/80" data-id="element-11">{text}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={containerVariants} className="bg-white/50 p-8 md:p-10 rounded-3xl border border-cream-200" data-id="element-12">
            <motion.h3 variants={itemVariants} className="text-2xl font-bold font-playfair mb-6 flex items-center" data-id="element-13">
              <span className="bg-red-100 p-2 rounded-full mr-3" data-id="element-14">
                <XCircle className="w-6 h-6 text-red-400" data-id="element-15" />
              </span>
              Para quién NO es:
            </motion.h3>
            <ul className="space-y-4" data-id="element-16">
              {['Personas que buscan una cura médica para condiciones digestivas crónicas.', 'Quienes esperan perder 10 kilos de grasa en dos días (esto es para inflamación y líquidos).', 'Personas que no están dispuestas a seguir instrucciones sencillas por 48 horas.'].map((text, i) => <motion.li key={i} variants={itemVariants} className="flex items-start" data-id="element-17">
                  <div className="w-1.5 h-1.5 rounded-full bg-red-300 mt-2.5 mr-3 flex-shrink-0" data-id="element-18"></div>
                  <span className="text-forest/70" data-id="element-19">{text}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>

        <LeafDivider data-id="element-20" />

        {/* How it works */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={containerVariants} className="mt-20 max-w-4xl mx-auto" data-id="element-21">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-bold font-playfair text-center mb-12" data-id="element-22">
            ¿Cómo funciona el proceso?
          </motion.h2>

          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-sage-300 before:via-sage-400 before:to-sage-300" data-id="element-23">
            {[{
            step: '1',
            title: 'Preparación Nocturna',
            desc: "Descarga el manual y realiza la 'Apertura de Ganglios' esta misma noche antes de dormir."
          }, {
            step: '2',
            title: 'Nutrición Estratégica',
            desc: 'Sigue el menú de alimentos desinflamatorios y toma los elixires anti-cortisol en los horarios indicados.'
          }, {
            step: '3',
            title: 'Activación Linfática',
            desc: 'Aplica el masaje de drenaje 10 minutos antes de dormir y al despertar para ver resultados visuales inmediatos.'
          }].map((item, idx) => <motion.div key={idx} variants={itemVariants} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-24">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-cream-100 bg-sage-500 text-white font-bold shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-25">
                  {item.step}
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-white p-6 rounded-2xl shadow-sm border border-cream-200" data-id="element-26">
                  <h4 className="font-bold text-xl mb-2 text-forest" data-id="element-27">
                    {item.title}
                  </h4>
                  <p className="text-forest/70 m-0" data-id="element-28">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}